export default function clean_sum_ret_data(in_data_ss) {
  const cleandata_nivo_line = in_data_ss.map(function (item) {
    var clean = Object.keys(item).filter(function (d) {
      return (
        d !== "Ticker" &&
        d !== "Name" &&
        d !== "Sector" &&
        d !== "Industry" &&
        d !== "skew" &&
        d !== "ivPercent" &&
        d !== "eDate" &&
        d !== "expMove" &&
        d !== "prevMove"
      );
    });
    var newArray = [];
    clean.forEach((key, index) =>
      newArray.push({ x: index, y: +item[key], date: key })
    );
    // console.log(clean)
    console.log(item);
    var ret_obj = {
      data: newArray,
      id: item["Ticker"],
      name: item["Name"],
      sector: item["Sector"],
      industry: item["Industry"],
      skew: item["skew"],
      ivPercent: item["ivPercent"],
      eDate: item["eDate"],
      expMove: item["expMove"],
      prevMove: item["prevMove"]
    };
    return ret_obj;
  });
  return cleandata_nivo_line;
}
